import { render, staticRenderFns } from "./OtherXueshi.vue?vue&type=template&id=1c5e3254&scoped=true"
import script from "./OtherXueshi.vue?vue&type=script&lang=js"
export * from "./OtherXueshi.vue?vue&type=script&lang=js"
import style0 from "./OtherXueshi.vue?vue&type=style&index=0&id=1c5e3254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e3254",
  null
  
)

export default component.exports